module.exports = __webpack_public_path__ + "img/glasses-type_grey.944ce4df.svg";